/**
 * Created by jigar on 6/9/16.
 */
'use strict';
export default class categoriesService {
    constructor($http,$q) {
        'ngInject';
        this._$http = $http;
        this._$q = $q;

    }


   
    updateCategories(file) {
        console.log("In service updateCategories===");
        let deferred = this._$q.defer();
        var option = {
            method: 'POST',
            url: '/api/updateCustomerGroupCategories',
            headers: {'Content-Type': undefined},
            transformRequest: function (data) {
                var formData = new FormData();
                for (var key in data) {
                    formData.append(key, data[key]);
                }
                return formData;
            },
            data: {'file':file}
        };
        console.log("option",option);
        this._$http(option).success(function(data){
            console.log("ERVICE RESPONSE::",data);
            if( data.Status=="success"){
                deferred.resolve(data);
            }
            else {
                console.log("in error");
                deferred.reject(data);
            }
        }).error(function(err){
            deferred.reject(err);
        });
        return deferred.promise;
    }





    updatePrice(file) {
        console.log("In service updatePrice===");
        let deferred = this._$q.defer();
        var option = {
            method: 'POST',
            url: '/api/updateCustomerGroupPrice',
            headers: {'Content-Type': undefined},
            transformRequest: function (data) {
                var formData = new FormData();
                for (var key in data) {
                    formData.append(key, data[key]);
                }
                return formData;
            },
            data: {'file':file}
        };
        console.log("option",option);
        this._$http(option).success(function(data){
            console.log("1212",data);
            if( data.Status=="success"){
                deferred.resolve(data);
            }
            else {
                console.log("in error");
                deferred.reject(data);
            }
        }).error(function(err){
            deferred.reject(err);
        });
        return deferred.promise;
    }


}


// WEBPACK FOOTER //
// ./src/app/modules/categories/categories.service.js